import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment AutopilotSuggestionInvite_org on Org {
      id
    }
  `,
  inviteOrganizerKnob: graphql`
    fragment AutopilotSuggestionInvite_inviteOrganizerKnob on InviteOrganizerKnob {
      __typename
      suggestedInvitee
      affectedEventIds
      affectedGoals
      knobScore
      knobUrn {
        id
        type
        value
      }
      affectedGoalsForEvents {
        externalEventId
        affectedGoals
      }
      suggestedInviteePerson {
        ... on Person {
          primaryEmail
          profile {
            givenName
            familyName
            externalImageUrl
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
    }
  `,
  referencedEvents: graphql`
    fragment AutopilotSuggestionInvite_referencedEvents on Event @relay(plural: true) {
      title
      isAllDay
      startTime {
        millis
      }
      endTime {
        millis
      }
      eventKey {
        externalEventId
      }
    }
  `,
};
